import { Platform } from '@angular/cdk/platform';
import { AfterViewInit, Component, DestroyRef, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { createAndObserveIntersection } from 'src/app/shared/helpers/createAndObserveIntersection';

@Component({
    selector: 'app-generic-table',
    templateUrl: './generic-table.component.html',
    styleUrls: ['./generic-table.component.scss'],
    standalone: false
})
export class GenericTableComponent<TItem extends object> implements OnInit, AfterViewInit, OnDestroy {
  safariBrowser = false;
  private destroyRef = inject(DestroyRef);
  private resizeObserver?: ResizeObserver;

  @ViewChild('endOfList') endOfList: ElementRef;
  @ViewChild('tableContent', {static: false}) tableContent: ElementRef;
  @ViewChild('scrollBarContainer', {static: false}) scrollBarContainer: ElementRef;
  @ViewChild('scrollBarContent', {static: false}) scrollBarContent: ElementRef;
  @ViewChild('genericTable') genericTable: ElementRef;

  @Output() scrolledToEnd = new EventEmitter<boolean>();
  @Output() safariSettings = new EventEmitter<boolean>();
  @Input() enableHorizontalScroll: boolean = false;

  constructor(public platform: Platform) {}

  ngOnInit(): void {
    // if (this.platform.SAFARI) {
    //   this.safariBrowser = true;
    //   this.safariSettings.emit(true);
    // }
  }

  ngAfterViewInit(): void {
    createAndObserveIntersection(this.endOfList)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(isVisible => {
        if (isVisible) {
          this.scrolledToEnd.emit(true);
        }
      });

    this.resizeObserver = new ResizeObserver(() => {
      this.syncScrollbarWidth();
    });
    this.resizeObserver.observe(this.tableContent.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  syncScrollbarWidth(): void {
    if (this.genericTable && this.scrollBarContainer && this.enableHorizontalScroll) {
      const componentRect = this.genericTable.nativeElement.getBoundingClientRect();
      const componentWidth = componentRect.width;
      const componentLeft = componentRect.left;
      this.scrollBarContainer.nativeElement.style.width = `${componentWidth}px`;
      this.scrollBarContainer.nativeElement.style.left = `${componentLeft}px`;
    }
  }

  syncScroll(event: any) {
    if (this.enableHorizontalScroll) {
      this.tableContent.nativeElement.scrollLeft = event.target.scrollLeft;
    }
  }

  onWheel(event: WheelEvent) {
    if (this.enableHorizontalScroll) {
      if (event.shiftKey) {
        this.scrollBarContainer.nativeElement.scrollLeft += event.deltaY;
      } else if (event.deltaX !== 0) {
        this.scrollBarContainer.nativeElement.scrollLeft += event.deltaX;
      }
    }
  }
}
